/* eslint-disable react/prop-types */
import { Card, CardHeader, Grid, Icon } from "@mui/material";

import { useNavigate } from "react-router-dom";
import { roles } from "~/config";
import DashboardLayout from "~/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "~/examples/Navbars/DashboardNavbar";
import useAuthorization from "~/hooks/useAuthorization";
import MDBox from "./MDBox";
import MDButton from "./MDButton";

const GenericTableContainer = ({
  cardHeaderTitle,
  careSubHeaderTitle = "",
  cardButtonText,
  navigateTo,
  startIcon = "add",
  children,
  ...otherProps
}) => {
  const navigate = useNavigate();
  const { userHasRequiredRole } = useAuthorization([roles.ADMIN]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={0.5}
                px={2}
                variant="gradient"
                bgColor="success"
                borderRadius="lg"
                coloredShadow="success"
                color="white"
              >
                <CardHeader
                  action={
                    userHasRequiredRole && (
                      <MDButton
                        aria-label="navigation"
                        startIcon={<Icon>{startIcon}</Icon>}
                        onClick={() => navigate(navigateTo, { replace: true })}
                      >
                        {cardButtonText}
                      </MDButton>
                    )
                  }
                  title={cardHeaderTitle}
                />
              </MDBox>
              <MDBox pt={3}>{children}</MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default GenericTableContainer;
